import React from 'react';
import { Link } from 'react-router';

/** Review page for each kind — see pages/weightrax-review. */
export const WEIGHTRAX_REVIEW_PATHS = {
  product: '/operations/catalogue-items/review',
  customer: '/master-data/customers/review',
} as const;

/**
 * The "Linked — needs review" status as a link to the review page, so nobody
 * has to find it via the tab. Stops the click reaching the row (which would
 * open the edit form instead).
 */
export function WeightraxReviewCell({ kind }: { kind: keyof typeof WEIGHTRAX_REVIEW_PATHS; row?: any }) {
  return (
    <Link
      to={WEIGHTRAX_REVIEW_PATHS[kind]}
      className="text-amber-700 dark:text-amber-400 underline underline-offset-2 hover:no-underline"
      onClick={(e) => e.stopPropagation()}
    >
      Linked — needs review
    </Link>
  );
}
